import type { FindTourOperatorsInput } from '@travel-planner/shared/schemas/operations';
import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

export const useTourOperatorsData = (
  input: FindTourOperatorsInput,
  options?: Options
) =>
  trpc.operations.tourOperatorsList.useQuery(input, {
    enabled: options?.enabled ?? true,
  });
